/* eslint-disable import/order */
import { MenuIdSettings } from '@jira/navigation-apps__constants/src/MenuIdSettings.tsx';
import { SidebarIdGlobalProductsSettings } from '@jira/navigation-apps__constants/src/SidebarIdGlobalProductsSettings.tsx';
import ErrorPagesNotFound from '@jira/router-routes__common/src/ui/error-pages/not-found/index.tsx';
import { globalSettingsLayout } from '@jira/platform__layouts-global-settings-layout/src/index.tsx';
import { createEntry } from '@jira/platform__routing-route-entry/src/createEntry.tsx';
import { fg } from '@atlassian/jira-feature-gating';
import {
	getNavigationResources,
	getNavigationSidebarProductsSettingResource,
} from '@jira/router-resources__navigation/src/getNavigationResources.tsx';
import { polarisSettingsViewBlueprintsRoute } from '@jira/router-routes__polaris-routes/src/polarisSettingsViewBlueprintsRoute.tsx';
import { polarisProductViewBlueprintsSettingsPageEntryPoint } from './ui/settings/view-blueprints/index.tsx';
import type { Route } from '@atlassian/react-resource-router';

export const polarisSettingsViewBlueprintsRouteEntry: Route = createEntry(
	polarisSettingsViewBlueprintsRoute,
	() => ({
		isStrictModeEnabled: false,
		group: 'global-settings',
		layout: globalSettingsLayout,

		navigation: {
			sidebarId: SidebarIdGlobalProductsSettings,
			menuId: MenuIdSettings,
		},

		// eslint-disable-next-line no-restricted-syntax
		component: ErrorPagesNotFound,
		resources: [...getNavigationResources(), ...getNavigationSidebarProductsSettingResource()],

		entryPoint() {
			return fg('jpd-view-templates-sample-project')
				? polarisProductViewBlueprintsSettingsPageEntryPoint
				: undefined;
		},

		bifrost: {
			bifrostGroup: 'shell-only',
		},
	}),
);
